import styled from "styled-components"

import TSVGProps from "../SVGTypes"

type TLogoProps = TSVGProps & {
  color?: string
  className?: string
  bgColor?: string
  bgStroke?: string
  [x: string]: any
}

function PlayIcon({
  color = "none",
  strokeWidth,
  strokeColor,
  bgColor,
  bgStroke,
  ...props
}: TLogoProps) {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      {...props}
    >
      <circle
        fill={bgColor}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
        cx="64"
        cy="64"
        r="60.7"
      />
      <polygon
        points="39.6,39.2 92,64 39.6,88.8"
        fill={color}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
      />
    </SVG>
  )
}

export default PlayIcon

const SVG = styled.svg`
  pointer-events: none;
`
